import { Navigate, useLocation, useParams } from "react-router";

/**
 * OWN-346: old sell/store URLs keep working. `to` is relative to the workspace and may carry its
 * own query; the visitor's query string is kept and the target's wins on a clash.
 */
export function StoreRedirect({ to }: { readonly to: string }) {
  const { workspaceId } = useParams();
  const { search } = useLocation();
  const [path = "", ownQuery] = to.split("?");
  const query = new URLSearchParams(search);
  new URLSearchParams(ownQuery).forEach((value, key) => query.set(key, value));
  const qs = query.toString();
  return <Navigate replace to={`/w/${workspaceId}/${path}${qs ? `?${qs}` : ""}`} />;
}
